import React, { useState } from 'react';
import { FileTextIcon, UsersIcon, DollarSignIcon, TruckIcon, FileCheckIcon } from 'lucide-react';
import { QuoteStepHeader } from '../shared/QuoteStepHeader';
import { QuoteStepNavigation } from '../shared/QuoteStepNavigation';
import { ProjectDetailsStep } from './ProjectDetailsStep';
import { CustomerInfoStep } from '../shared/CustomerInfoStep';
import { ProjectItemsStep } from './ProjectItemsStep';
import { ShippingTermsStep } from '../shared/ShippingTermsStep';
import { QuoteReviewStep } from '../shared/QuoteReviewStep';
export function ProjectQuoteFlow({
  initialData = null
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [quoteData, setQuoteData] = useState({
    projectDetails: initialData?.projectDetails || {},
    customerInfo: initialData?.customerInfo || {},
    items: initialData?.items || [],
    shipping: initialData?.shipping || {},
    // Preservar otros datos importantes si estamos editando
    ...(initialData && {
      id: initialData.id,
      quoteNumber: initialData.quoteNumber,
      date: initialData.date,
      status: initialData.status,
      expiryDate: initialData.expiryDate,
      quotedBy: initialData.quotedBy,
      type: 'Project'
    })
  });
  const steps = [{
    label: 'Project Details',
    icon: <FileTextIcon size={16} data-id="element-4573" data-mp="2o31z18jrgfzq" />
  }, {
    label: 'Customer Info',
    icon: <UsersIcon size={16} data-id="element-4574" data-mp="2o0o4d0szt5sp" />
  }, {
    label: 'Project Items',
    icon: <DollarSignIcon size={16} data-id="element-4575" data-mp="20dzlabs8z7ai" />
  }, {
    label: 'Shipping & Terms',
    icon: <TruckIcon size={16} data-id="element-4576" data-mp="1vewcqhd26ixs" />
  }, {
    label: 'Review',
    icon: <FileCheckIcon size={16} data-id="element-4577" data-mp="1vca56hq643fk" />
  }];
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      // Submit quote
      console.log('Submit quote', quoteData);
    }
  };
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleSave = () => {
    console.log('Save draft', quoteData);
  };
  const updateQuoteData = (section, data) => {
    setQuoteData({
      ...quoteData,
      [section]: data
    });
  };
  return <div className="bg-slate-800/30 rounded-xl border border-blue-800/30 p-6" data-id="element-4578" data-mp="3gqevoz687qeo">
      <QuoteStepHeader steps={steps} currentStep={currentStep} onChangeStep={setCurrentStep} data-id="element-4579" data-mp="3lhn6nzn7fjty" />
      <div className="mt-8" data-id="element-4580" data-mp="3qh00x5gent6k">
        {currentStep === 0 && <ProjectDetailsStep initialData={quoteData.projectDetails} onUpdate={data => updateQuoteData('projectDetails', data)} data-id="element-4581" data-mp="3qghz7taz4mr9" />}
        {currentStep === 1 && <CustomerInfoStep initialData={quoteData.customerInfo} onUpdate={data => updateQuoteData('customerInfo', data)} data-id="element-4582" data-mp="2xs2kl7vr86gg" />}
        {currentStep === 2 && <ProjectItemsStep initialData={quoteData.items} onUpdate={data => updateQuoteData('items', data)} data-id="element-4583" data-mp="32q47k3wawpx7" />}
        {currentStep === 3 && <ShippingTermsStep initialData={quoteData.shipping} onUpdate={data => updateQuoteData('shipping', data)} data-id="element-4584" data-mp="i1gf2ri2dd1j" />}
        {currentStep === 4 && <QuoteReviewStep quoteData={quoteData} quoteType="Project" data-id="element-4585" data-mp="mzhwz93r76bf" />}
      </div>
      <QuoteStepNavigation currentStep={currentStep} totalSteps={steps.length} onNext={handleNext} onBack={handleBack} onSave={handleSave} isFinalStep={currentStep === steps.length - 1} data-id="element-4586" data-mp="27j3jj0es823p" />
    </div>;
}